import React, { useState } from 'react';
import MarkdownPage from '../components/MarkdownPage';
import page1 from '../pages/content/page1.md';
import page2 from '../pages/content/page2.md';
import page3 from '../pages/content/page3.md';
import './ArticlePage.css'; // Import the CSS file for styles

const pages = [page1, page2, page3];

const ArticlePage = () => {
  const [currentPage, setCurrentPage] = useState(0);

  const goToNextPage = () => {
    if (currentPage < pages.length - 1) setCurrentPage(currentPage + 1);
    window.scrollTo(0, 0); // Scroll to the top of the page
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
    window.scrollTo(0, 0); // Scroll to the top of the page
};

  return (
    <div className="article-container">
        <div className="pagination-controls">
        <button
          onClick={goToPreviousPage}
          disabled={currentPage === 0}
          className="pagination-button"
        >
          Previous
        </button>
        <button
          onClick={goToNextPage}
          disabled={currentPage === pages.length - 1}
          className="pagination-button"
        >
          Next
        </button>
      </div>
      <div className="markdown-container">
        <MarkdownPage file={pages[currentPage]} />
      </div>
      <div className="pagination-controls">
        <button
          onClick={goToPreviousPage}
          disabled={currentPage === 0}
          className="pagination-button"
        >
          Previous
        </button>
        <button
          onClick={goToNextPage}
          disabled={currentPage === pages.length - 1}
          className="pagination-button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ArticlePage;
